/** Eureka 全部历史查询响应。 */
export interface EurekaAllHistoryResponse {
    /** 当前账号的历史任务总数。 */
    total: number;
}

/** Eureka 全部历史 API。 */
export interface EurekaAllHistoryApi {
    /**
     * 查询当前账号的全部历史任务。
     * @returns 包含历史任务总数的响应。
     */
    getAllHistory(): Promise<EurekaAllHistoryResponse>;
}

/** Eureka 全部历史 API 的容器标识。 */
export const EurekaAllHistoryApi = Symbol('EurekaAllHistoryApi');
